import React, { useContext } from 'react'
import RecordSection from './_RecordSection'
import InfoLine from './_InfoLine'
import moment from 'moment'
import { GlobalContext } from '../../../../App'
import { regionLabels } from '../../../../helpers/region'

const PatientDetails = ({ epcr, anonymised }) => {
  const { tenantInfo } = useContext(GlobalContext)
  return (
    <RecordSection title="Patient Details">
      {anonymised ? (
        <InfoLine
          label="Age"
          value={
            epcr.demographics.dobUnknown
              ? 'UNKNOWN'
              : epcr.demographics.dob
                ? moment().diff(epcr.demographics.dob, 'years')
                : ''
          }
        />
      ) : (
        <>
          <InfoLine
            label="Last Name"
            value={
              epcr.demographics.lastNameUnknown
                ? 'UNKNOWN'
                : epcr.demographics.lastName
            }
          />
          <InfoLine label="First Name" value={epcr.demographics.firstName} />
          <InfoLine
            label="Preferred Name"
            value={epcr.demographics.preferredName}
          />
          <InfoLine
            label="DOB"
            value={
              epcr.demographics.dobUnknown
                ? 'UNKNOWN'
                : epcr.demographics.dob
                  ? moment(epcr.demographics.dob).format('Do MMMM YYYY')
                  : ''
            }
          />
          <InfoLine label="Gender" value={epcr.demographics.gender} />
          <InfoLine label="GP Surgery" value={epcr.demographics.gpSurgery} />
          <InfoLine
            label={regionLabels(tenantInfo?.region).nationalIdLabel}
            hideIfEmpty
            value={epcr.demographics.nhsNumber}
          />
          <InfoLine
            label="Address"
            value={[
              epcr.demographics.addressLine1,
              epcr.demographics.addressLine2,
              epcr.demographics.town,
              epcr.demographics.city,
              epcr.demographics.postCode,
            ]
              .filter(Boolean)
              .join(', ')}
          />
          <InfoLine
            label="Contact Number"
            value={epcr.demographics.contactNumber}
          />
          <InfoLine
            label="Number for Feedback"
            value={
              epcr.demographics.consentsToSMS
                ? epcr.demographics.numberForFeedback
                : 'Not Consented'
            }
          />
          <InfoLine
            label="Next of Kin Name"
            value={epcr.demographics?.nokName}
            hideIfEmpty
          />
          <InfoLine
            label="NOK Relationship"
            value={epcr.demographics?.nokRelationship}
            hideIfEmpty
          />
          <InfoLine
            label="NOK Contact Number"
            value={epcr.demographics?.nokContactNumber}
            hideIfEmpty
          />
        </>
      )}
    </RecordSection>
  )
}

export default PatientDetails
